export default __webpack_public_path__ + "static/media/team54.a655fa4d.JPG";